module.exports = __webpack_public_path__ + "img/ic_warning_small.b70a2df5.svg";